import {useEffect, useState} from 'react';
import NetInfo from '@react-native-community/netinfo';

/**
 * Are we offline? True when the device reports no connection, or a connection the OS
 * has determined can't actually reach the internet (`isInternetReachable === false`) —
 * captive portals and dead Wi-Fi both count as offline for our purposes.
 *
 * Starts optimistic (false) so a first render never flashes the banner before NetInfo
 * has answered; the initial fetch and the subscription then correct it.
 */
export function useIsOffline(): boolean {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    const apply = (isConnected: boolean | null, reachable: boolean | null) => {
      setOffline(isConnected === false || reachable === false);
    };
    // Answer once immediately, then track changes.
    void NetInfo.fetch().then(s => apply(s.isConnected, s.isInternetReachable));
    const unsubscribe = NetInfo.addEventListener(s =>
      apply(s.isConnected, s.isInternetReachable),
    );
    return unsubscribe;
  }, []);

  return offline;
}
